import { Directive, HostListener, Input } from '@angular/core';
import { BackBeaconService } from '../services/back-beacon.service';

/**
 * 
 * */
@Directive({
  selector: '[beaconTrack]'
})
export class BeaconTrackDirective {
  @Input() beaconTrack: any;

  constructor(private beaconService: BackBeaconService) { }

  @HostListener('click')
  onClick() {
    this.beaconService.track(this.beaconTrack);
  }
}
